import { useState } from 'react';
import { categoryData } from '@/mocks/categories';

export default function CategoryGrid() {
  const [showAll, setShowAll] = useState(false);
  const displayedCategories = showAll ? categoryData : categoryData.slice(0, 8);

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="mx-auto" style={{ maxWidth: 1200 }}>
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
          <div>
            <span className="inline-block text-sm font-medium text-accent-700 bg-accent-100/80 px-3 py-1 rounded-full mb-3">
              Trending GTBuy
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              Explore Spreadsheet <span className="italic text-accent-700">Categories</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground-500 bg-background-200/70 px-3 py-1.5 rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
              Live Updates
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {displayedCategories.map((cat, idx) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-50 rounded-lg overflow-hidden hover:scale-[1.03] transition-all duration-300 flex flex-col cursor-pointer"
              style={{
                animationDelay: `${idx * 50}ms`,
              }}
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>
              </div>
              <div className="flex items-center justify-between px-3 py-3 md:px-4 md:py-3.5">
                <div className="flex items-center gap-2.5 min-w-0">
                  <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg bg-background-100 group-hover:bg-primary-100/70 transition-colors flex-shrink-0">
                    <i className={`${cat.icon} text-foreground-600 group-hover:text-primary-700 text-sm md:text-base transition-colors`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors leading-tight truncate">
                    {cat.name}
                  </span>
                </div>
                <span className="text-xs text-foreground-400 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0 ml-2">
                  →
                </span>
              </div>
            </a>
          ))}
        </div>

        {categoryData.length > 8 && (
          <div className="flex justify-center mt-8">
            <button
              onClick={() => setShowAll(!showAll)}
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 text-foreground-700 text-sm font-medium rounded-full border border-background-200/70 hover:border-foreground-300 hover:text-foreground-950 transition-all cursor-pointer whitespace-nowrap"
            >
              {showAll ? 'Show Less' : `View All ${categoryData.length} Categories`}
              {showAll ? <i className="ri-arrow-up-s-line text-sm"></i> : <i className="ri-arrow-down-s-line text-sm"></i>}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}